// Angular
import { Inject, Injectable } from '@angular/core';

// Local library
import { EPROTECT, SessionService } from '@amwager/data-access';
import { LoadService, MatNotificationService } from '@amwager/util';
import { IEProtect, eProtectConfigure } from '@amwager/util-ts';

// Local file
import { FundingFacade, IDebitCreditCard } from '../+state';

/** Business logic for the deposit "add card" (eProtect) component. */
@Injectable()
export class DepositAddAccountCardService {

  constructor(
    @Inject(EPROTECT) private readonly eProtect: IEProtect,
    private readonly sessionService: SessionService,
    private readonly loadService: LoadService,
    private readonly fundingFacade: FundingFacade,
    private readonly matNotificationService: MatNotificationService,
  ) {}

  /** Load the eProtect + jQuery CDN scripts. */
  addEProtectScripts(): Promise<void> {
    return this.loadService.addScripts([
      { id: 'JQueryCDN', url: this.eProtect.jQuery },
      { id: 'eProtectCDN', url: this.eProtect.url }
    ]);
  }

  /** Remove the eProtect + jQuery CDN scripts. */
  removeEProtectScripts(): Promise<void> {
    return this.loadService.removeScripts(['JQueryCDN', 'eProtectCDN']);
  }

  /** Build the eProtect iframe configuration with the given callbacks. */
  buildEProtectConfig(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardCallback: (response: any) => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emptyCallback: (response: any) => void
  ) {
    return eProtectConfigure(
      this.sessionService.getPayPageId(),
      this.eProtect.css,
      this.eProtect.reportGroup,
      cardCallback,
      emptyCallback
    );
  }

  /** Build the unique eProtect registration message (max lengths preserved). */
  buildRegistrationMessage(): { id: string; orderId: string } {
    const id = this.sessionService.generateSessionId();
    const orderId = this.sessionService.generateSessionId();

    return {
      id: btoa(id).substring(0, 24),      // unique, max 25
      orderId: btoa(orderId).substring(0, 24), // unique, max 256
    };
  }

  /** Dispatch add-card and stream the result. */
  insertCard$(newCard: IDebitCreditCard) {
    this.fundingFacade.addDebitCreditCard(newCard);
    return this.fundingFacade.isAddDebitCreditCardSuccess$();
  }

  /** Show a single-button alert. */
  showAlert(header: string, message: string): void {
    this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
  }

}
